import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// const API_URL = getApiBaseUrl();
 const API_URL = getApiBaseUrl();


// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


const getDatosQuiebra = async () => {
  try {
    const response = await api.get(`${API_URL}quiebra`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};


const getOneDatosTicket = async (serie) => {
  try {
    const response = await api.get(`${API_URL}quiebra/getone/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatosTicketR = async (id) => {
  try {
    const response = await api.get(`${API_URL}quiebra/getoneTicket/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatosRetallos = async (id) => {
  try {
    const response = await api.get(`${API_URL}quiebra/getoneRetallo/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatosImagen = async (id) => {
  try {
    const response = await api.get(`${API_URL}quiebra/getoneImagen/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};


// const getOneHorarios = async (id) => {
//   try {
//     return response.data;
//   } catch (error) {
//     throw new Error('Error al obtener datos del backend:', error);
//   }
// };

const PostDatosQuiebra = async (datos) => {
  try {
    const response = await api.post(`quiebra`, datos);

    return response.data;
  } catch (error) {

    if (error.response && error.response.data && error.message) {
      // Si el error es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      // Si el error no es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

export { getDatosQuiebra, PostDatosQuiebra, getOneDatosTicket, getOneDatosTicketR, getOneDatosRetallos, getOneDatosImagen };